/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Msg_SuccessInputs */

const es_footer_msg_success = /** @type {(inputs: Footer_Msg_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Gracias! Te hemos apuntado. Revisa tu bandeja de entrada y confirma el email que te hemos enviado.`)
};

const gl_footer_msg_success = /** @type {(inputs: Footer_Msg_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grazas! Apuntámoste. Revisa a túa bandexa de entrada e confirma o correo que che enviamos.`)
};

const en_footer_msg_success = /** @type {(inputs: Footer_Msg_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanks! You are signed up. Check your inbox and confirm the email we sent you.`)
};

/**
* | output |
* | --- |
* | "Thanks! You are signed up. Check your inbox and confirm the email we sent you." |
*
* @param {Footer_Msg_SuccessInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_msg_success = /** @type {((inputs?: Footer_Msg_SuccessInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Msg_SuccessInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_msg_success(inputs)
	if (locale === "en") return en_footer_msg_success(inputs)
	return es_footer_msg_success(inputs)
});